<div class="dialog dialog-tickets">
  <div>
    <div class="dialog__header">
      <h3 class="dialog__title">{{ "Dialog.Tickets.Title" | translate }}</h3>
      <svg-icon src="assets/images/icons/x.svg" class="dialog__close" mat-dialog-close></svg-icon>
    </div>
    <div class="dialog-tickets__body">
      <div class="dialog-tickets__top">
        <p>{{ (isLocation() ? "Dialog.Tickets.DescriptionLocation" : "Dialog.Tickets.Description") | translate }}</p>
        @if (isLocation()) {
          <p>
            <a href="" (click)="viewAll($event)">{{ "Dialog.Tickets.ViewAll" | translate }} →</a>
          </p>
        }
      </div>

      <div class="dialog-tickets__table">
        <div class="dialog-tickets__table-row">
          <div>{{ "Dialog.Tickets.Name" | translate }}</div>
          <div>{{ "Dialog.Tickets.ID" | translate }}</div>
          <div>{{ "Dialog.Tickets.Startdate" | translate }}</div>
          <div>{{ "Dialog.Tickets.Status" | translate }}</div>
        </div>
        @for (ticket of visibleTickets; track ticket.ticketId) {
          <div class="dialog-tickets__table-row">
            <div [title]="ticket.summary">{{ ticket.summary }}</div>
            <div>{{ ticket.ticketId }}</div>
            <div>{{ ticket.created | date: "d MMM y, HH:mm" : undefined : currentLang() }}</div>
            <div>{{ ticket.statusLabel }}</div>
          </div>
        } @empty {
          <empty-state
            [icons]="['notification']"
            [title]="(isLocation() ? 'Dialog.Tickets.EmptyLocation' : 'Dialog.Tickets.Empty') | translate"
          ></empty-state>
        }
      </div>

      @if (hiddenCount > 0) {
        <p class="dialog-tickets__truncation">
          {{ "Dialog.Tickets.Truncated" | translate: { shown: visibleTickets.length, total: totalCount } }}
        </p>
      }
    </div>
  </div>
</div>
